module.exports = __webpack_public_path__ + "img/menu_HOME.e602b099.svg";